import React from "react";
import PageShell from "@/components/PageShell";
import { ShieldCheck } from "lucide-react";

const INTRO =
  "سوف تجدون أدناه الشروط والأحكام المُنظّمة لاستخدامكم لهذا الموقع وكافة الآثار القانونية التي تنتج عن استخدامكم لخدماتنا عبر الشبكة العنكبوتية. استخدام أي شخصٍ كان للموقع يعتبر موافقة وقبول منه وهو بكامل أهليته المعتبرة شرعاً ونظاماً وقانوناً لكافة مواد وأحكام هذه الاتفاقية.";

const ARTICLES = [
  {
    title: "المادة الأولى — المقدّمة والتعريفات",
    body:
      "يعتبر التمهيد أعلاه جزءاً لا يتجزأ من هذه الاتفاقية. (الموقع) يشمل كافة أشكال الموقع على الشبكة العنكبوتية. (المستهلك) الشخص الذي يتعامل بالتجارة الإلكترونية رغبةً في الحصول على المنتجات أو الخدمات.",
  },
  {
    title: "المادة الثانية — أهلية المستهلك القانونية",
    body:
      "يقر المستهلك بأنه ذا أهلية قانونية معتبرة للتعامل مع الموقع، أو أن عمره لا يقل عن 18 عاماً.",
  },
  {
    title: "المادة الثالثة — طبيعة الالتزام",
    body: "إن التزام الموقع تجاه المستهلكين هو توفير الخدمة أو المنتج الرقمي.",
  },
  {
    title: "المادة الرابعة — ضوابط الاستخدام",
    body:
      "يلتزم المستهلك باستخدام المنصة بما يتّفق مع الآداب العامة والأنظمة المعمول بها في المملكة العربية السعودية.",
  },
  {
    title: "المادة الخامسة — الحسابات والتزامات التسجيل",
    body:
      "فور التقدم بطلب الانضمام إلى عضوية في هذا الموقع تكون ملتزماً بالإفصاح عن معلومات محددة واختيار اسم مستخدم وكلمة مرور سرية. أنت مسؤول عن المحافظة على سرية معلومات حسابك، وتلتزم باستخدام حسابك بنفسك.",
  },
  {
    title: "المادة السادسة — الاتصالات الإلكترونية",
    body:
      "يوافق أطراف هذه الاتفاقية على أن التواصل يتم عبر البريد الإلكتروني المسجّل في المنصّة.",
  },
  {
    title: "المادة السابعة — التعديلات والرسوم",
    body:
      "يحتفظ الموقع بحقه في إضافة أو زيادة أو خفض أي رسوم أو نفقات بموجب مواد وبنود اتفاقية الاستخدام.",
  },
  {
    title: "المادة الثامنة — خدمات الدفع",
    body: "يوفّر الموقع عبر شركائه نظام الدفع والسداد إلكترونياً عبر الإنترنت.",
  },
  {
    title: "المادة التاسعة — الملكية الفكرية",
    body:
      "إن حقوق الملكية الفكرية الخاصة بالموقع ومحتوياته والكتب الرقمية هي حقوق مملوكة ملكية تامة للمؤلف، ويُمنع استخدامها لأغراض تجارية دون إذن مسبق. يمنع تسجيل الجلسات او نشرها او مشاركتها بأي شكل من الاشكال.",
  },
  {
    title: "المادة العاشرة — المسؤولية",
    body:
      "يلتزم الموقع بأن يمارس عمله التجاري بشكل نظامي ووفقاً للأنظمة المعمول بها في المملكة العربية السعودية. الموقع لا يتحمل أي مطالبات تنشأ عن أخطاء أو إهمال ناتجة بشكل مباشر أو غير مباشر عن طريق المستهلك.",
  },
  {
    title: "المادة الحادية عشر — تقييد الولوج",
    body:
      "يمكن للموقع وقف أو إلغاء عضوية المستهلك أو تقييد ولوجه إلى الخدمات في أي وقت وبدون إنذار ولأي سبب.",
  },
  {
    title: "المادة الثانية عشر — القانون الواجب التطبيق",
    body:
      "اتفاقية الاستخدام هذه محكومة ومصاغة بحسب القوانين والأنظمة والتشريعات المعمول بها والسارية في المملكة العربية السعودية.",
  },
];

const TermsAndPrivacy = () => (
  <PageShell>
    <section
      className="max-w-3xl mx-auto px-6 lg:px-12 py-16"
      data-testid="terms-privacy-page"
    >
      <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full bg-[#F6F4EE] border border-[#E5E1D8] text-[#0A4D3C] text-sm">
        <ShieldCheck className="w-4 h-4" /> اتفاقية الاستخدام والخصوصية
      </div>
      <h1 className="font-heading text-4xl sm:text-5xl text-[#222222] mt-6">
        اتفاقية الاستخدام والخصوصية
      </h1>
      <p className="text-[#5E5C58] mt-4 leading-loose">{INTRO}</p>

      <div className="mt-10 space-y-4" data-testid="terms-privacy-articles">
        {ARTICLES.map((a, i) => (
          <article
            key={i}
            data-testid={`terms-privacy-article-${i + 1}`}
            className="rounded-2xl border border-[#E5E1D8] bg-[#FAF9F6] p-5 sm:p-6"
          >
            <h2 className="font-heading text-xl text-[#0A4D3C]">{a.title}</h2>
            <p className="mt-3 text-[#222222] leading-loose text-base">{a.body}</p>
          </article>
        ))}
      </div>

      <p className="mt-10 text-sm text-[#5E5C58] leading-relaxed">
        لأي استفسار بخصوص شروط الاستخدام أو الخصوصية، يمكنك التواصل مع{" "}
        <span className="font-semibold text-[#222222]">خدمة العملاء</span> عبر الواتساب على{" "}
        <a
          href="https://wa.me/966538278484"
          target="_blank"
          rel="noopener noreferrer"
          dir="ltr"
          className="text-[#1ebe5b] hover:text-[#159b48]"
          data-testid="terms-privacy-whatsapp-link"
        >
          +966 53 827 8484
        </a>
        .
      </p>
    </section>
  </PageShell>
);

export default TermsAndPrivacy;
